import { cn } from '../../lib/cn';
import type { AppShellProps } from './app-shell.types';

export function AppShell({
  sidebar,
  mobileNav,
  children,
  sidebarCollapsed,
  fullBleed = false,
}: AppShellProps) {
  return (
    <div className="flex h-screen bg-[var(--a-bg)] [font-family:var(--a-body)]">
      {sidebar}
      <div
        className={cn(
          'flex flex-1 flex-col overflow-hidden transition-all duration-300',
          sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-60',
        )}
      >
        <main
          className={
            fullBleed
              ? 'flex-1 overflow-y-auto pb-20 lg:pb-0'
              : 'flex-1 overflow-y-auto p-4 pb-20 lg:p-6 lg:pb-6'
          }
        >
          {children}
        </main>
      </div>
      {mobileNav}
    </div>
  );
}
